import { COLOR_RGB } from "../../constants";
import { globalVars } from "../../globalVariables";
import { colorInterpolate } from "../../utils/colorInterpolate";
import { getQT } from "../../utils/dom";
export const updateGCTimer = () => {
    const minT = Game.shimmerTypes.golden.minTime;
    const maxT = Game.shimmerTypes.golden.maxTime;
    const difT = maxT - minT;
    const t = Game.shimmerTypes.golden.time;
    const internalT = Math.max(0, t - minT);
    const timeToMin = Math.ceil((minT - t) / Game.fps);
    const timeToMax = Math.ceil(Math.min(difT, maxT - t) / Game.fps);
    const timerString = `${timeToMin > 0 ? `${timeToMin}+` : ""}${timeToMax}s`;
    // formula source: i made that up
    const GCChance = (1 -
        Math.exp((-5 * (internalT / Game.fps) ** 5.93) / (difT / Game.fps) ** 5)) *
        100;
    const GCChanceColor = colorInterpolate(COLOR_RGB.red, COLOR_RGB.green, Math.min(1, GCChance / 50));
    const GCTimer = getQT("GCTimer");
    if (!GCTimer)
        return;
    if (globalVars.natGCOnScreen) {
        GCTimer.innerHTML = `<span>GC: On screen</span>`;
        return;
    }
    GCTimer.innerHTML = `<span>GC: ${timerString}</span> <span style="color: rgb(${GCChanceColor.toString()});">${GCChance.toFixed(1)}%</span>`;
};
